/**
 * `components.MuiButtonBase` — shared ripple / interaction defaults for buttons and icon buttons.
 * Discoverability: `MuiButtonBase`, `disableRipple`, `ButtonBase`.
 *
 * @see https://mui.com/material-ui/api/button-base/
 *
 */
import type { Components, Theme } from '@mui/material/styles';

export function muiButtonBase(_theme: Theme): Pick<Components<Theme>, 'MuiButtonBase'> {
  return {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
  };
}
